var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{staticClass:"simple-select",attrs:{"searchable":false,"show-labels":false,"options":_vm.options,"multiple":true,"value":_vm.value,"placeholder":"групувати за ... ","custom-label":_vm.labelingFunction,"max":2},on:{"input":v => this.$emit('input', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }